import React from 'react'

const CourseDes = () => {
    return (
        <div className='container container1'>

            <div className="courseDes-Heading">
                <h1>Courses - Department of Information Technology</h1>
                <h2>NIT SRINAGAR</h2>
                <p id="last-updated">Last Updated: 2019</p>
            </div>

            {/* Harshit Dubey Sections */}

            <section id='ITL100'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITL100 &nbsp; Computer Programming</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br /><p >
                    <b>Introduction to C Programming</b>:  Engineering problem solving methodology, Flow
                    charts, Tracing flow charts, Algorithms, Need for computer Languages, computer languages,
                    High-level languages, History of C, A simple C Program. <br />
                    <b>C Language preliminaries</b>:  Program structure, C character set, Identifiers and keywords,
                    Data types, Declarations, Expressions, statements symbolic constants, Library functions, preprocessors,
                    # include, #define <br />
                    <b>Input-Output</b>: getchar, putchar, scanf, printf, gets, puts and other related input output
                    functions. <br />
                    <b>Operators and expressions</b>:  operators in C,arithmetic ,unary, logical, bit-wise, assignment
                    and conditional operators. <br />
                    <b>Control statements</b>: if else, switch, break, Continue, and goto statements,
                    While, do-while, for statements, nested loops, loops using goto. comma operators and
                    variants of above control structure. <br />
                    <b>Functions</b>: Defining and accessing, passing arguments, Function prototypes, Recursion,
                    Library functions, Static functions <br />
                    <b>Arrays</b>: Defining and processing, Passing arrays to a function, matrices as 2D arrays,
                    Multi dimensional arrays. <br />
                    <b>Pointers</b>: Declarations, Passing pointers to a function, Operations on pointers, Pointer
                    Arithmetic, Pointers and arrays, Arrays of pointers and function pointers. Dynamic memory
                    allocation of arrays and higher dimensional arrays using malloc() function. <br />
                    <b>Strings Fundamentals</b>: of character and strings, string handling library functions,
                    pointer to strings, dynamic allocation for strings. <br />
                    <b>Structures and Unions</b>:Defining and accessing structure, structure as function arguments, array of
                    structures, pointers to structures, defining and accessing union. <br />
                    <b>File Handling</b>:Files, asciifiles , binary files,File operation such as storing , retrieving and
                    updating a file. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To provide exposure to problem solving through programming</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>To understand the Syntax and Semantics of the C language.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To understand the basics of programming including the most common library functions
                                    and the usage of the pre-processor.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To understand the concept of loops and to learn how to write a program in C using loops.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>To understand the data types offered by the C language including complex data types:
                                    arrays, structures and pointers.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>To understand the concept of strings in programming.</td>
                            </tr>
                            <tr>
                                <td>CO7</td>
                                <td>To understand the concept of file handling in programming.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Schaums outline of Theory and Problems of programming with C: Gottfried <br />
                    2. Mastering C by Venugopal, Prasad – TMH <br />
                    3. Programming in ANSI C, Balaguruswamy <br />
                    4. C How to Program, P. J. Deitel and H. Deitel <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM" target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITP100'>
                <hr /><br />
                <p><span className="title">ITP100 &nbsp;  Computer Programming Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br /><p>
                    <b className="courseD-heading">Lab Details:</b> <br />
                    1. Programs to understand how integers, characters, and strings are stored and represented in C. <br />
                    2. Programs to understand the ASCII character encoding. <br />
                    3. Programs to understand how to use different operators available in C. <br />
                    4. Programs to understand differences between a logical and arithmetic operators. <br />
                    5. Programs to understand differences between a logical and bitwise operators. <br />
                    6. Programs to obtain a full understanding of signed, unsigned, long and short numbers in C. <br />
                    7. Programs to understand exactly how numbers are represented in computers(octal,hexadecimal
                    and binary numbers systems) . <br />
                    8. Programs to evaluate algebraic expressions in C. <br />
                    9. Programs to understand printing of various data types using different output functions. <br />
                    10. Programs to exercise all flags in printf() functions. <br />
                    11. Programs to understand printing of display patterns of numbers and asterisks. <br />
                    12. Programs to understand taking input from user using different input functions. <br />
                    13. Programs to exercise all flags in scanf() functions. <br />
                    14. Programs to understand how arrays work in C, how to use them, and how they are stored in
                    memory. <br />
                    15. Programs to understand searching in an array. <br />
                    16. Programs to understand sorting techniques using arrays. <br />
                    17. Programs to understand pointers in C. <br />
                    18. Programs to understand the relationship between array indexing and pointer arithmetic. <br />
                    19. Programs to understand dynamic memory allocation especially with respect to1D and 2D
                    arrays. <br />
                    20. Programs to understand modularize of code using functions. <br />
                    21. Programs to implement function with/without arguments and with/without return types. <br />
                    22. Programs to understand direct and indirect recursions using functions. <br />
                    23. Programs to use pointer to pass the address of data and arrays to functions. <br />
                    24. Programs to understand static data types and static functions. <br />
                    25. Programs to understand creating, accessing and using structures. <br />
                    26. Programs to understand use of arrays of structures. <br />
                    27. Programs to understand pointers to structures and pointers as structures members. <br />
                    28. Programs to understand creating, accessing and using unions. <br />
                    29. Programs to understand creating, reading, writing a file. <br />
                    30. Programs to understand taking input through arguments to main() function. <br /> <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To provide exposure to problem solving through programming.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>To understand the concept of various tools available in C and to learn how to solve the problems using the code.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To understand the basics of programming including the most common library functions.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To learn how to write a program in C using loops, functions, pointers etc.</td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITT201'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT201 &nbsp; Data Structures</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p >
                    <b>Introduction</b>:Basic concept of data, structures and pointers.<br />
                    <b>Arrays</b>:Representation, implementation, polynomial representation. Limitations<br />
                    <b>Strings</b>:Representation, String operations, Implementing String.h library functions<br />
                    <b>Linked List</b>: Static and dynamic implementation. Single, double, circular, multiple linked lists. <br />
                    <b>Stacks</b>: Recursion and Stacks. Static and dynamic implementation. Expression evaluation. Infix, postfix expressions, multiple stacks.<br />
                    <b>Queues</b>:Static and dynamic implementation, circular queues, and implementation.<br />
                    <b>Hash Tables</b>: Hash tables implementation. Hashing techniques, single, double.<br />
                    <b>Storage Management</b>:Memory Management techniques, garbage collection. <br />
                    <b>Trees</b>:Binary trees, binary search trees, static and dynamic implementation. Tree
                    operations, insert, delete, and search.<br />
                    <b>Heaps</b>:Implementation, sorting etc.<br />
                    <b>Sorting and Searching</b>:Different sorting techniques. Insertion sort, selection sort, bubble sort, radix sort, quick sort, merge sort, heap sort. <br />
                    <b>Graphs</b>:Representation of graphs, BFS, DFS sort. Graph Algorithms.<br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand basic data structures such as arrays, strings, and linked lists.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Study linear data structures such as stacks and queues and understand their
                                    difference.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Describe the hash function and concepts of collision and its resolution methods. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Understand the concept of memory management.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Study tree, heap and graphs along with their basic operations.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Study different techniques for solving problems like sorting and searching.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Data Structures by Rajni Jindal <br />
                    2. Data Structures - Schaum‘s Series <br />
                    3. Data Structures by Knuth <br />
                    4. Data Structures by Farouzan <br />
                    5. Data Structures using C and C++ by Langsam, Augestern, Tanenbaum. <br /> <br />

                    <a href="https://www.youtube.com/watch?v=zWg7U0OEAoE&list=PLBF3763AF2E1C572F" target="_blank">NPTEL DSA Playlist</a><br /><br />
                </p>
            </section>

            <br />

            <section id='ITT202'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT202 &nbsp; Signals & Systems</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p >
                    <b>Introduction to signals: </b>
                    Classification of signals; Deterministic and non-deterministic, periodic and aperiodic, even
                    and odd signals, energy and power signals, elementary signals; exponential, sinusoidal,
                    impulse, step, ramp, pulse, square wave signals. Time shifting, time scaling and
                    timeinversions of signals<br />
                    <b>Linear Time invariant systems: </b>
                    Continuous time system, basic system properties like causality, time invariance, stability,
                    linearity, memory, order of system, interconnection of systems, Linear time invariant
                    systems, characterization, unit impulse response , convolution, properties of LTI systems,
                    linear constant co-efficient differential equations and system description.<br />
                    <b>Fourier analysis of signals and systems: </b>
                    Fourier series of periodic signals and its properties, Fourier transform of aperiodic signals
                    and its properties, fourier transform of periodic signals, convolution in time and frequency
                    domain, energy and signals, parsevals theorem, energy spectral density and its properties,
                    Transfer function of LTI system.<br />
                    <b>The Laplace Transform: </b>
                    Definition, relation between Laplace and Fourier transforms, region of convergence,
                    properties of Laplace transform, initial and final value theorems, convolution, transfer
                    function of LTI system, concept of poles and zeroes, stability criteria.<br />
                    <b>Random variable theory and random signals: </b>
                    Probability, conditional probability, statistical independence, random variables, discrete
                    and continuous random variables, probability distribution and probability density functions,
                    statistical averages of random variables. Some important density functions.<br />
                    <b>Random processes and characterization: </b>
                    Ensemble and time averages, stationary and non-stationary random process, wide sense
                    stationary random process, autocorrelation and cross-correlation functions, response of LTI
                    systems to random inputs, noise and its types, white noise, signal to noise ratio of LTI
                    systems.<br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand the basic classification, properties and operations on signals.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Understand the basic classification, properties of systems and LTI systems.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Finding the Fourier and inverse transform of signals and its properties. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Finding the Laplace and Inverse transform of signals and its properties.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>To understand use of probability distribution function and density for signals and
                                    Systems.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Using autocorrelation and cross correlation functions and noise in LTI systems.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Signals and Systems by Zieman, Tranter, Fannin<br />
                    2. Signals and Systems by Sanjay Sharma  <br /><br />

                    <a href="https://www.youtube.com/watch?v=0nZYen9w_eo&list=PLyqSpQzTE6M8KJ-XQ1m2vl3nd2ZUqKEN8" target="_blank">NPTEL Signal And System Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='ITT203'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT203&nbsp; Software
                    Engineering</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br /><p>
                    <b>Unit I - Software Process:</b><br />
                    The Evolving role of Software , Defining Software, Software Myths, Legacy software, A
                    generic view of process, A layered Technology, Process Framework, Capability Maturity
                    Model Integration (CMMI), Process Assessment, Personal and Team Process Models,
                    Product and Process, Process Models – Build and fix model, The Waterfall Model,
                    Incremental Process Model, RAD Model, Evolutionary Process Models, Unified Process,
                    Agile Methodology, SCRUM Approach. <br />
                    <b>Unit II - Requirement Engineering:</b><br />
                    Software Engineering Practice, Requirements Engineering tasks, Types of requirements,
                    Feasibility studies, initiating the requirements Engineering Process, Eliciting
                    Requirements, Developing Use cases, Requirement Analysis, Documentation and
                    validation, Building the Analysis Model, Elements of the Analysis Model. <br />
                    <b>Unit III -Analysis Modeling And Project Planning:</b><br />
                    Requirements Analysis, Analysis Modeling approaches, data modeling concepts, Object
                    oriented Analysis, Scenario based modeling, Flow oriented Modeling, Class based
                    modeling, creating a behavior model. Planning: Size estimation, Cost estimation,
                    COCOMO, Software risk management. <br />
                    <b>Unit IV - Design & Implementation:</b><br />
                    Design Engineering, Design Concepts, Modularity, Strategy of Design, Function oriented
                    Design, Architectural Design, Detailed Design, Design process, Design Quality, Design
                    model, User interface Design, Implementation, issues in implementation. Software
                    metrics, SCM. <br />
                    <b>Unit V - Testing & Maintenance:</b><br />
                    Testing strategies, Testing Tactics and terminologies, functional testing, structural testing,
                    levels of testing, validation testing, system testing, Art of debugging. Software
                    maintenance, maintenance models, Regression testing, Reverse Engineering,
                    ReEngineering, evolution, Quality Management, Process Improvement, Risk
                    Management.
                    <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Students will know classical and evolving software engineering methods, can
                                    select and tailor appropriate methods for projects, and can apply them as both
                                    team members and managers to achieve project goals.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Ability to effectively apply software engineering practice over the entire system
                                    lifecycle. This includes requirements engineering, analysis, prototyping, design,
                                    implementation, testing, maintenance activities and management of risks
                                    involved in software and embedded systems. </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To make students proficient in effective written and oral communication skills
                                    so that they can prepare and publish the necessary documents required
                                    throughout the project lifecycle. It also includes effectively contributing to
                                    project discussions, presentations, and reviews. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To make students knowledgeable of the ethics, professionalism, and cultural
                                    diversity in the work environment and develop an awareness of the role and
                                    responsibilities of the professional software Engineers and Understanding
                                    software testing approaches such as unit testing and integration testing along
                                    with the need for lifelong learning and readily adapting to new software
                                    engineering environments. </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>To understand use of probability distribution function and density for signals and
                                    Systems.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Using autocorrelation and cross correlation functions and noise in LTI systems.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Ian Sommerville, “Software Engineering”, Pearson Education. <br />
                    2. Software Engineering – A Practitioner’s Approach, Roger S. Pressman, McGraw Hill. <br />
                    3. Software Engineering, K.K. Aggarwal, Yogesh Singh, New Age International
                    Publishers.<br /><br />

                    <a href="https://www.youtube.com/watch?v=Ln_LP7c23WM&list=PLbRMhDVUMngf8oZR3DpKMvYhZKga90JVt" target="_blank">NPTEL Software Engineering Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='ITT204'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT204&nbsp; Discrete
                    Mathematics & Graph
                    Theory </span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p>
                    <b>Unit I - Sets and Relations:</b><br />
                    Sets, Relations, Representation of Relations, Composition of Relations, Partitions,
                    Equivalence Relations. Ordered sets and Lattices: Ordered sets, Diagram of Partially
                    ordered sets, Supremum and Infimum, well ordered sets, Lattices, Bounded and
                    complemented lattice, Distributive Lattice. <br />
                    <b>Unit II - Propositional Calculus:</b><br />
                    Statements, Basic operations, Truth value of compound statements, Algebra of
                    Propositions, Tautologies and contradiction, Conditional and Bi-conditional statements,
                    logical implications,logical equivalence, predicates, Universal and existential
                    quantifiers.Logic gates, Boolean Algebra, Postulates of Boolean Algebra; Theorems of
                    Boolean Algebra, Sum of products and product of sums Simplification. <br />
                    <b>Unit III - Proof techniques:</b><br />
                    Notions of implication, converse, inverse, contrapositive, negation, and contradiction; the
                    structure of formal proofs; direct proofs; proof by counterexample; proof by contraposition;
                    proof by contradiction; mathematical induction. <br />
                    <b>Unit IV - Graph Theory:</b><br />
                    Graphs and Multi-graphs, Degree of a vertex, Paths connectivity, Cut points Bridges,
                    Walks, paths, cycles, connected graphs, Bipartite, Regular,Planar and connected
                    graphs,Euler graphs, Euler's theorem, Hamiltonian path and circuits, Graph coloring,
                    chromatic number, isomorphism and Homomorphism of graphs,Konigsberg seven bridge
                    problem, Shortest path. Trees, properties of trees, pendant vertices in trees, Degree
                    sequences in trees, Necessary and sufficient conditions for a sequence to be a degree
                    sequence of a tree. <br />
                    <b>Unit V - Group Theory:</b><br />
                    Groups, semigroup, infinite group, Finite group, order of a group, Abelian group, subgroup,
                    Lagrange's Theorem, Cosets, Normal Subgroups, order of an element of a group, cyclic
                    group. Rings , Homomorphism and Isomerphism of rings. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand discrete structures such as sets, relations, and lattices.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Study the basic operations of Propositional logic and Boolean Algebra.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Analyse and study various proof techniques. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Understand basics of Graph theory and how it can be used to visualize and
                                    simplify problems. </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Understand the various properties of algebraic systems like Rings, Monoids
                                    and Groups.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. C. L. Liu : Elements of Discrete Mathematics, 2nd Ed.Tata Mc-Graw Hill. <br />
                    2. Kolman, Busby and Ross : Discrete Mathematical Structers, 6th Ed.PHI (2009). <br />
                    3. NarsinghDeo : Graph Theory with Applications to Engineering and Computer Sciences,
                    PHI. <br />
                    4. Murry R. Spiegel: Discrete Mathematics (Schaums Outline series) Tata McGraw Hill
                    (2009). <br />
                    5. K. Bogart, S. Drysdale, C. Stein. Discrete Math for Computer Science Students. <br /><br />

                    <a href="https://www.youtube.com/watch?v=xlUFkMKSB3Y&list=PL0862D1A947252D20" target="_blank">NPTEL Discrete Mathematics Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='CST201'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">CST201&nbsp;  Object Oriented
                    Programming </span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p>
                    <b>1. Classes and Objects:</b>
                    Need of Object-Oriented Programming (OOP), Object
                    Oriented Programming Paradigm, Basic Concepts of Object-Oriented
                    Programming, Benefits of OOP, C++ as object oriented programming language.
                    C++ Programming- C++ programming Basics, Data Types, Structures,
                    Enumerations, control structures, Arrays and Strings, Class, Object, class and
                    data abstraction, class scope and accessing class members, separating interface
                    from implementation, controlling access to members. Functions- Function,
                    function prototype, accessing function and utility function, Constructors and
                    destructors, Copy Constructor, Objects and Memory requirements, Static Class
                    members, data abstraction and information hiding, inline function. <br />
                    <b>2. Polymorphism and Inheritance:</b>
                    Operator Overloading- concept of
                    overloading, operator overloading, Overloading Unary Operators, Overloading
                    Binary Operators, Data Conversion, Type casting (implicit and explicit), Pitfalls
                    of Operator Overloading and Conversion, Keywords explicit and mutable.
                    Inheritance- Base Class and derived Class, protected members, relationship
                    between base Class and derived Class, Constructor and destructor in Derived
                    Class, Overriding Member Functions, Class Hierarchies, Inheritance, Public
                    and Private Inheritance, Levels of Inheritance, Multiple Inheritance, Ambiguity
                    in Multiple Inheritance, Aggregation, Classes Within Classes. Polymorphismconcept, relationship among objects in inheritance hierarchy, abstract classes,
                    polymorphism. <br />
                    <b>3. Virtual Functions:</b>
                    Virtual Functions- Pointers- indirection Operators,
                    Memory Management: new and delete, Pointers to Objects, A Linked List
                    Example, accessing Arrays using pointers, Function pointers, Pointers to
                    Pointers, A Parsing Example, Debugging Pointers, Dynamic Pointers, smart
                    pointers, shared pointers, Case Study : Design of Horse Race Simulation.
                    Virtual Function- Friend Functions, Static Functions, Assignment and Copy
                    Initialization, this Pointer, virtual function, dynamic binding, Virtual destructor. <br />
                    <b>4. Templates and Exception handling:</b>
                    Templates- function templates, Function
                    overloading, overloading Function templates, class templates, class template
                    and Non-type parameters, template and inheritance, template and friends
                    Generic Functions, Applying Generic Function, Generic Classes, The typename
                    and export keywords, The Power of Templates. Exception HandlingFundamentals, other error handling techniques, simple exception
                    handlingDivide by Zero, rethrowing an exception, exception specifications,
                    processing unexpected exceptions, stack unwinding, constructor, destructor and
                    exception handling, exception and inheritance. <br />
                    <b>5. Files and Streams:</b>
                    Data hierarchy, Stream and files, Stream Classes, Stream Errors,
                    Disk File I/O with Streams, File Pointers, and Error Handling in File I/O, File I/O with
                    Member Functions, Overloading the Extraction and Insertion Operators, memory as a
                    Stream Object, Command-Line Arguments, Printer output, Early vs. Late Binding. <br />
                    <b>6.Standard Template Library:</b>
                    Standard Template Library, Overview of Standard
                    Template Library, Containers, Algorithms, Iterators, Other STL Elements, Container
                    Classes, General Theory of Operation, Vectors. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Analyze the strengths of object oriented programming.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Design and apply OOP principles for effective programming.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Develop programming application using object oriented programming language C++ ·Percept
                                    the utility and applicability of OOP. </td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Robert Lafore, “Object Oriented Programming in Turbo C++”, Galgotia
                    Publications, <br />
                    2.Balagurusamy, “Object Oriented programming with C++”, Tata McGraw Hill. <br /><br />

                    <a href="https://www.youtube.com/watch?v=WpJ_yiwbGyk&list=PLJ5C_6qdAvBHslIkD7JB7kBdgv1SeXy3P" target="_blank">NPTEL Object Oriented
                        Programming Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='CSL203'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">CSL203&nbsp;  Object Oriented
                    Programming Lab </span></p>
                <p><span className="credits">2 credits (0-0-2)</span></p>
                <br /><p>1.
                    Function overloading and default arguments in C++ <br />
                    2.
                    Simple class design in C++, namespaces, object creation <br />
                    3.
                    Class design in C++ using dynamic memory allocation <br />
                    4.
                    Constructors and destructors <br />
                    5.
                    Operator overloading and friend functions <br />
                    6.
                    Overloading assignment operator and type conversions <br />
                    7.
                    Inheritance, run time polymorphism and virtual functions <br />
                    8.
                    Template design in C++ <br />
                    9.
                    Interface and abstract classes <br />
                    10. Exception handling <br />
                    11. File handling in C++<br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Apply C++ features to program design and implementation.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Explain object-oriented concepts and describe how they are supported by C++.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Use C++ to demonstrate practical experience in developing object-oriented solutions. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Analyse a problem description and design and build object-oriented software using good coding
                                    practices and techniques. </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Use common software patterns in object-oriented design and recognise their applicability to
                                    other software development contexts. </td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Robert Lafore, “Object Oriented Programming in Turbo C++”, Galgotia
                    Publications. <br />
                    2.Balagurusamy, “Object Oriented programming with C++”, Tata
                    McGraw Hill.

                </p>
            </section>

            <br />

            <section id='ITL205'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITL205&nbsp;Data Structures
                    Lab</span></p>
                <p><span className="credits">2 credits (0-0-2)</span></p>
                <br /><p>Basic concepts of data, linear lists, strings, arrays and orthogonal lists, representation of
                    trees
                    & graphs, storage systems, Arrays, Recursion, Stacks, Queues, Linked lists, Binary trees,
                    General Trees, Tree Traversal, Symbol Table and Searching Techniques,
                    Sorting Techniques. <br /> <b> Graphs:</b>
                    <br />
                    1. Implement singly and doubly linked lists. <br />
                    2. Represent a polynomial as a linked list and write functions for polynomial addition. <br />
                    3. Implement stack and use it to convert infix to postfix expression. <br />
                    4. Implement array-based circular queue and use it to simulate a producer-consumer
                    problem. <br />
                    5. Implement an expression tree. Produce its pre-order, in-order, and post-order traversals. <br />
                    6. Implement a binary search tree. <br />
                    7. Implement priority queue using heaps. <br />
                    9. Implement hashing techniques. <br />
                    10. Implement various sorting techniques as taught in class. <br />
                    11. Implement Dijkstra's algorithm using priority queues. <br />
                    12. Implement Prim's and Kruskal's algorithms <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Implement and understand linked lists for polynomial manipulation. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Study stack data structure and use it for expression parsing (prefix, infix, postfix).</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Implement circular queues for producer-consumer problem simulation.  </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Implement search trees and priority queues using heaps.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Implement various hashing techniques. </td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Study and implement various searching and sorting techniques.  </td>
                            </tr>
                            <tr>
                                <td>CO7</td>
                                <td>Implement various Graph Algorithms.</td>
                            </tr>
                        </tbody>
                    </table>

                </p>
            </section>

            <br />

            {/* Rahul Kumar Sections */}

            <section id='ITT250'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT250&nbsp;Operating
                    Systems </span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p><b>Unit 1-Introduction: </b><br />
                    Computer System Overview-Basic Elements, Instruction Execution, Operating system
                    functions and structure, Interrupts, Memory Hierarchy, Cache Memory, Direct Memory
                    Access, Multiprocessor and Multicore Organization. Operating system overview-objectives
                    and functions, Evolution of Operating System, Distributed OS. <br />
                    <b>Unit 2-Process Management And Coordination: </b> <br />
                    Process concept, Process States, Process Description and Process Control, Interprocess
                    Communication, Processes and Threads, Types of Threads, Multicore and Multithreading. <br />
                    <b>Unit 3-Concurrency AND Scheduling: </b><br />
                    Principles of Concurrency - Mutual Exclusion, Semaphores, Monitors, Readers/Writers
                    problem. Deadlocks – prevention- avoidance – detection, Scheduling- Types of Scheduling –
                    Scheduling algorithms. <br />
                    <b> Unit 4-Memory Management:</b><br />
                    Memory management requirements, Partitioning, Paging and Segmentation, Virtual memory
                    - Hardware and control structures, operating system software, Linux memory management,
                    Windows memory management. Virtual memory management. <br />
                    <b> Unit 5-Input/Output And File Systems:</b>
                    <br />
                    I/O management and disk scheduling – I/O devices, organization of I/O functions; OS design
                    issues, I/O buffering, disk scheduling, Disk cache. File management – Organization,
                    Directories, File sharing, and Record blocking, secondary storage management.  <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Functions of operating System. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Operating System processes, management and coordination. </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Interprocess Communication and process control. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Deadlocks detection, prevention and avoidance mechanisms.  </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td> Process Scheduling Algorithms.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Memory and I/O Device Management.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Silberschatz, Peter Galvin, Greg gagne “Operating System Principles”. <br />
                    2. William Stallings, “Operating Systems – internals and design principles”, Prentice
                    Hall.
                    <br /> <br />
                    <a href="https://www.youtube.com/watch?v=z3Nw5o9dS7Q&list=PLsylUObW5M3CAGT6OdubyH6FztKfJCcFB" target="_blank">NPTEL Operating System Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='ITT251'>
                <hr /><br />
                <p><span className="title courseD-mainHeading">ITT251&nbsp;Database
                    Management System</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p><b>Unit 1-Introduction: </b><br />
                    Introduction to database management, data abstraction and system structure, Purpose of database
                    system , uses of database approach, database applications, Views of data, Database languages,
                    Database system – Concepts and architecture, Database users and administrator, database types.<br />
                    <b>Unit 2-Data Modelling: </b> <br />
                    Data models definition and types, Entity- Relationship Model (E-R Model), E-R diagrams, entity set,
                    relationship sets, mapping, cardinalities. Introduction to relational databases, The relational model -
                    Keys, Relational algebra – Domain relational calculus – Tuple relational calculus – Fundamental
                    operations – Additional operations – SQL fundamentals, Views, Introduction to distributed databases
                    and client/server databases. <br />
                    <b>Unit 3-Database Design: </b><br />
                    Relational database design, Functional dependencies, Non-loss decomposition, First, Second, Third
                    Normal Forms – Dependency Preservation – Boyce/Codd Normal Form, Multi-Valued Dependencies
                    and higher normal Forms. <br />
                    <b> Unit 4-Transactions:</b><br />
                    Transaction Concepts, Transaction Recovery, ACID Properties, System Recovery, Media recovery,
                    Two phase commit, Save points, SQL facilities for recovery, Concurrency, Need for concurrency,
                    Locking protocols - Two phase locking, Intent locking, Deadlock, Serializability, Recovery isolation
                    levels, SQL facilities for concurrency.
                    <br />
                    <b> Unit 5-Implementation Techniques:</b>
                    <br />
                    Overview of physical storage media – Magnetic disks, Tertiary storage, File organization –
                    Organization of records in files, Indexing and hashing, ordered indices, B trees index files, Static
                    hashing, dynamic hashing, RAID organization and levels. Data warehouse and data mining- basic
                    concepts and overview. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Identify the basic concepts and various data model used in Database design. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Apply relational database theory and be able to describe relational algebra expression, tuple and domain
                                    relation expression for queries and SQL for implementing the queries.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Recognize and identify the use of normalization and functional dependency. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Apply and relate the concept of transaction, concurrency control and recovery in database </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>: Recognize / identify the purpose of query processing and optimization, indexing and hashing technique
                                    used in database design. </td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. R. and Navathe, S.B., “Fundamentals of Database Systems”, Pearson Education.
                    <br /> <br />
                    <a href="https://youtu.be/x5qRAihZRks" target="_blank">Gate Academy Playlist</a><br /><br />

                </p>
            </section>

            <br />

            <section id='ECT251'>
                <hr /><br />
                <p><span className="title courseD-mainHeading" >ECT251&nbsp; Digital
                    Electronics & Logic Design</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br /><p> <b>Binary Systems:</b>  Number Systems (binary, octal, hexadecimal), conversion
                    from one system to another, addition and subtraction using different number
                    systems, complements and codes. <br />
                    <b>Boolean algebra & Logic Gates:</b>  Basic Definitions, Theorems and Properties
                    of Boolean Algebra, Boolean functions, Canonical and Standard Forms, Logic
                    Operations & Gates <br />
                    <b> Simplification of Boolean Functions:</b> K-Map Method and Tabulation Method
                    (2, 3, 4, 5 variables) <br />
                    <b> Combinational Logic:</b> Design Procedure, Logic gates and Arithmetic Circuits <br />
                    <b> Combinational Logic with MSI & LSI:</b> Adder, Subtractor, Encoders,
                    Decoders, Multiplexers, De-multiplexers ,ROMs, PLA‘s <br />
                    <b> Sequential Logic:</b> Moore and Mealy Machine Design Procedure state machine
                    as a sequential controller, Flip-Flops (FF), Triggering, Analysis, State
                    Reduction &Assignment. FF Excitation Tables, ASM Charts, Design Procedure,
                    Design of Counters, Design with State Equations. <br />
                    <b> Registers, Counters:</b> Shift Registers, Synchronous and Asynchronous
                    Counters
                    Data Converters: ADC, DAC and their types. <br />
                    <b> VHDL Programming: </b>Introduction, Code Structure, Data Types Operators
                    &Attributes, Concurrent Code, Sequential Code, Signals & Variables, Basic
                    Circuit Designs.  <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Use number systems, binary addition and subtraction. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Understand the different switching algebra theorems and apply them for logic functions.

                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Use the Karnaugh map for reduction of logic functions. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Design the combinational circuits.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Design the sequential circuits.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Derive the state-machine analysis or synthesis.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />1.
                    Digital Logic & Computer Design by M Morris Mano <br />
                    2.
                    Digital Electronics by Gupta & Singhal <br />
                    3.
                    Circuit Design with VHDL, V A Pedroni. <br /> <br />
                    <a href="https://youtu.be/x5qRAihZRks" target="_blank">Gate Academy Playlist</a><br /><br />

                </p>
            </section>

            <br />

            {/* DEDL Lab And Os Lab Missing */}

            <section id='ITL253'>
                <hr /><br />
                <p><span className="title courseD-mainHeading" > ITL253&nbsp;Database
                    Management System Lab</span></p>
                <p><span className="credits">2 credits (0-0-2)</span></p>
                <b>List Of Experiments:</b>
                <br /><p> 1. Creation of a database and writing SQL queries to retrieve information from the
                    database. <br />
                    2. Performing Insertion, Deletion, Modifying, Altering, Updating and Viewing records
                    based on conditions. <br />
                    3. Creation of Views for different users. <br />
                    4. Creating an Employee database to set various constraints. <br />
                    5. Creating relationship between the databases. <br />
                    6. Study of PL/SQL block. <br />
                    7. Creation of Procedures. <br />
                    8. Creation of database triggers, cursors and functions. <br /><br />
                    <b> Mini project (Application Development using Oracle/ Mysql/DB2)</b>
                    <ul>
                        <li>Inventory Control System.</li>
                        <li>Material Requirement Processing.</li>
                        <li>Hospital Management System.</li>
                        <li>Railway Reservation System.</li>
                        <li>Personal Information System.</li>
                        <li>Web Based User Identification Syste</li>
                        <li>Timetable Management System.</li>
                        <li>Hotel Management System</li>
                    </ul><br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Transform an information model into a relational database schema and to use a data definition
                                    language and/or utilities to implement the schema using a DBMS. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Analyze the database using queries to retrieve records. </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Formulatequery, using SQL, solutions to a broad range of queries, and data update problems. </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Applying PL/SQL for processing database.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Design the sequential circuits.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Analyse front end tools to design forms, menus, etc and establish back-end connectivity CO6:
                                    Develop solutions using database concepts for real-time requirements.</td>
                            </tr>
                        </tbody>
                    </table>

                </p>
            </section>

            <br />

            <section id='ITL254'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITL254&nbsp;Web
                    Programming </span></p>
                <p><span className="credits">4 credits (0-0-4)</span></p>
                <br /><p><b>Unit 1 - HTML & Introduction to CSS: </b>
                    HTML for structure, CSS for layout, and JavaScript for client-side programming; Suggestions
                    for learning. Web Site Basics: Dreamweaver, HTML: Elements. Attributes and values.HTML
                    Tables: Table, heading, row, data elements and attributes. Table structure not for page layout.
                    Links and server-side includes: HTML links and anchors. Linking to external files to
                    modularize html, build script libraries, or share styles; Server-side Includes. Standards: W3C,
                    the World Wide Web Consortium: W3C recommendations as standards.HTML rules:
                    Extensible markup languages; Frames: A glance at a common but deprecated element;
                    advantages and disadvantages; frame and frameset properties. Images:
                    Image types (JPG, GIF, PNG). Inline, embedded, and external styles. Writing Style Rules:
                    Writing CSS selectors and rules to tie style attributes and values to html elements. The
                    cascade: Inheritance, specificity, and the cascade.CSS positioning: Static, relative, and
                    absolute positioning. <br />
                    <b> Unit 2 - Introduction to JavaScript:</b>
                    Client-side programming for browsers. Event Handlers. JavaScript Overview: Language
                    characteristics. Variables. Assignment and comparison operators; expressions.HTML Forms:
                    The form element and inputs: textbox, radio buttons, checkbox, text area. <br />
                    <b> Unit 3 - Advanced HTML & CSS:</b>
                    HTML Form Basics, JavaScript, JavaScript Functions: Writing blocks of separate, reusable
                    code, Getting started with developing simple functions for form validators. Form Validation:
                    JavaScript for Simple Form Validation, The DOM and JavaScript Object Models: The W3C
                    Document Object Model; using nodes; DHTML: JavaScript + CSS = Dynamic HTML,
                    Advanced form validation: Javascript'sinner HTML and dynamic CSS for advanced form
                    validation. <br />
                    <b>Unit 4 - JavaScript Programming:</b>
                    Tracking the Mouse: Reporting the x and y position of the mouse, Annotating text: Adding hidden
                    text and accessing through JavaScript, Advanced JavaScript—Super Hypertexts: Finding. JavaScript's
                    Built-in Objects: Arrays. Dates. Math. Number and String Objects, Web Site Design / Redesign:
                    Overview of site redesign. Client survey. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Students will be able to create HTML Documents with formatting, images, tables, frames, embed
                                    multi-media objects and develop a static website using Hyper Text Mark-up Language. </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Students will learn how to Create web pages using Cascading Style Sheets. </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Students will design and implement dynamic websites with good aesthetic sense of designing
                                    and latest technical know-how's. </td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />1. Dietel & Dietel “Internet & Web Designing”. <br />
                    2. John Duckett. “JavaScript and Jquery: Interactive Front-end Web Development”.
                    <br /> <br />
                    <a href="https://youtu.be/x5qRAihZRks" target="_blank">Gate Academy Playlist</a><br /><br />

                </p>
            </section>

            <br />


            {/* Kundan Kumar Yadav Sections */}

            <section id='ITT301'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT301 &nbsp; Design & Analysis of Algorithm</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT 1 - Introduction</b> Algorithm Design paradigms - motivation, concept of algorithmic efficiency, run time analysis of
                    algorithms, Asymptotic Notations, Master theorem.<br />
                    <b>UNIT 2 - Divide &Conquer Methods</b>: Divide &amp; Conquer algorithms: examples, Binary search, Quick sort, Strassen’s algorithm
                    for matrix multiplication, analysis of divide and conquer runtime reference relations.<br />
                    <b>UNIT 3 - Dynamic Programming and Greedy paradigm</b>:Overview of dynamic programming, difference between dynamic programming and divide and
                    conquer. Dynamic Programming: Matrix Chain Multiplication (MCM), Longest Common
                    Subsequence (LCS), Optimal Binary Search Tree (OBST). Overview of the greedy paradigm.
                    General Greedy approach Vs Dynamic Programming approach Case studies: fractional Knapsack
                    vs 0/1 Knapsack problem.
                    <br />
                    <b>UNIT 4 - Graph searching and traversal</b>: Representation of Graphs, Breadth First Search, Depth First Search, Topological Sort, Strongly
                    Connected Components, examples of exact optimization solution (minimum cost spanning tree),
                    Dijkstra’s and Bellman ford algorithm, All pair shortest path, Flyod Warshall Algorithm <br />
                    <b>UNIT 5 - Backtracking and Computational complexity</b>:Back Tracking: Overview, 8-queen problem. Branch & amp; Bound: LC searching, bounding,
                    FIFO branch and bound, Travelling salesman problem. Computational complexity Complexity measures, Polynomial vs non-polynomial time complexity; NP hard and NP complete classes,
                    examples<br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>: Understand basics of algorithm efficiency and asymptotic notations.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>: Study various divide & conquer and greedy algorithms.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Understand the concept of dynamic programming with applications.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Study various graph searching and traversal algorithms.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Understand various computational complexity measures.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Introduction to Algorithms, by Cormen, Leiserson, Rivest, and Stein, MIT Press. <br />
                    <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT302'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT302 &nbsp; Microprocessor</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT 1 - Microprocessor-based Systems:Hardware And Interfacing</b>:Microprocessors, Microcomputers, and Assembly Language, Introduction to 8085 Assembly
                    Language Programming, Microprocessor Architecture and Microcomputer Systems, 8085
                    Microprocessor Architecture and Memory Interfacing Interfacing I/O Devices  <br />
                    <b>UNIT 2 - Programming The 8085</b>: Introduction to 8085 Instructions, Programming Techniques with Additional Instructions,
                    Counters and Time Delays, Stack and Subroutines, Code Conversion, BCD Arithmetic, and 16-
                    Bit Data Operations, Software Development, Assemblers, and IDE<br />
                    <b>UNIT 3 - Interfacing Peripherals(I/OS) And Applications</b>Interrupts, Interfacing Data Converters, Programmable Interface Devices: 8155 I/O and Timers:
                    8279 Keyboard / Display Interface, General Purpose Programmable Peripheral Devices, Serial I/O
                    and Data Communication, Microprocessor Applications, Trends in Microprocessor Technology
                    <br />
                    <b>UNIT 4 - Microprocessor 8086</b>: Pin diagram, Architecture, Addressing Modes, Timing diagram, Instruction Set, Programming
                    Techniques, Interrupt, Assembler Directives, Memory & I/O mapping <br />


                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>:Describe the general architecture & amp; organization of 8085 and 8086 Microprocessor and
                                    understand the difference between 8085 and advanced microprocessor.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>:Understand and classify the instruction set of 8085 and 8086 microprocessors and
                                    distinguish the use of different instructions and apply it in assembly language programming.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>:Ability to understand and write programs for stacks, delays, counters and subroutines.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>:Illustrate how the different peripherals (8255, 8279, etc.) are interfaced with Microprocessor
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>:Analyze the data transfer information through serial and parallel ports.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Ramesh S.Goankar, Microprocessor Architecture, Programming and Applications with the
                    8085 <br />
                    <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT303'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT303 &nbsp; Computer Organisation & Architecture</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT 1 - Introduction To Computer Architecture And Organisation</b>: Defining computer architecture and computer organization, classes of computers, basic structure
                    of computers, Operational concepts, performance and Amdhal’s law <br />
                    <b>UNIT 2 - Arithmetic And Logic Unit</b>:Microperations and their RTL specifications, Adder/Subtractor, Shifter, Multiplication and
                    division circuits, Arithmatic logic shift unit.
                    Arithmetic addition & Subtraction of Signed and unsigned numbers-algorithm and hardware,
                    Multiplication and division of Signed and unsigned numbers-algorithm and hardware, IEEE754
                    representation of Floating Point Numbers & Operations.  <br />
                    <b>UNIT 3 - Control And Processor Unit</b>: Control Unit: Machine instructions, Execution of a complete Instruction, Multiple Bus
                    organization, Hardwired control, Micro-programmed control.
                    Processor Unit: Components, organization types, addressing modes, Instruction types, Concept
                    of sub-routine and sub-routine call. Use of stack <br />
                    <b>UNIT 4 - I/O And Memory Unit</b>: I/O Unit: Synchronous vs. Asynchronous I/O, I/O techniques - interrupts, polling, DMA, IOP
                    Memory unit: Memory organization, Types of memories and performance considerations,
                    organization of memory modules, associative memory, cache memory and related mapping and
                    replacement policies, virtual memory <br />
                    Introduction to Pipelining: Concepts, Basic pipelining, Hazards. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand the basics of computer architecture and how it interacts with the software.
                                    Understand how computers represent and manipulate data. Understand computer arithmetic.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Understand how decisions made in hardware affect the software/programmer as well as
                                    hardware designer.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Understand the fundamental principles and tradeoffs in designing the hardware/software
                                    interface i.e., instruction set architecture.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Understand the design of major components of a modern programmable microprocessor.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Understand the techniques to improve the performance of the modern processors.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Understand the basics of the memory hierarchy in the high performance computers and the
                                    numerous techniques to improve the efficiency of the memory system.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Computer Organization, Hamachar, Vranesic & Zaky, TMH.<br />
                    2. Computer Organization & Architecture, M. M. Mano, PHI.<br />
                    <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT304'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT304 &nbsp; Theory of Computation</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT 1 - Introduction</b>:Mathematical Preliminaries and Notation, Sets, Relations, and Functions, Graphs, Methods of
                    Proof, Basic Concepts: Languages, Grammars, Automata, some applications.
                    Finite State Automata: Deterministic Finite acceptors, Deterministic acceptors and transitions
                    Graphs, Languages and DFAs, regular languages, Non-deterministic Finite Acceptors, Definition,
                    why Nondeterminism, Equivalence of NFA and DFA, Reduction of finite automata.mealy and
                    Moore machines.  <br />
                    <b>UNIT 2 - Regular Languages And Regular Grammars</b>: Regular expressions, definition, language associated with regular expressions, connection between
                    Regular expression and regular languages, regular grammars, right and left linear grammars.
                    Closure properties of regular languages under various operations, identifyingNonregular
                    languages. Pigeonhole principle, pumping lemma.<br />
                    <b>UNIT 3 - Context-Free Languages</b>: Definition of context free grammars, examples, leftmost and rightmost derivations, derivation
                    Tree, Parsing and ambiguity, parsing and membership, ambiguity in grammars and languages.
                    Context Free languages and programming languages. Methods for transforming grammars,
                    substitution rules, removing useless productions, removing λ-productions, Removing Unit
                    productions, Normal forms, Chomsky form, Greibach Normal form, Membership algorithms for
                    context fee grammars. Properties of CFL, pumping lemmas, closure properties and decision
                    algorithm properties, decidable properties of CFL. <br />
                    <b>UNIT 4 - Pushdown automata</b>: Definition of Pushdown Automata, Nondeterministic Pushdown Automata, languages accepted by
                    PDA, PDA for CFL,CFL for PDA, DPDA and DCFL. Grammars for CFLs.
                    Turing Machines: The Standard Turing Machine, Definition of a TuringMachine, Turing Machines
                    as Language AcceptersTuring Machines as Transducers, Combining Turing Machines for
                    Complicated Tasks, Turing's Thesis, variations on Turing machine. Nondeterministic Turing
                    machine <br />
                    <b>UNIT 5 - Undecidability</b>: The ChomskyHierarchy, Recursive and Recursively Enumerable Languages, Context-Sensitive
                    (grammars and Languages, A language that is not Recursively Enumerable (RE),problems that
                    cannot be solved by using Turing machine, An undecidable problem that isRE, Undecidable
                    problems about Turing Machine, Post’s Correspondence Problem ,the complexity classes P and
                    NP and language families. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td> Explore the different ways to reason about the correctness of algorithms for solving various
                                    computer science problems?</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Defining the working and properties of various computational models. How do we
                                    mathematically model computers?</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Designing finite automata and regular expressions, writing context-free grammars, reducing
                                    problems to one another.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Explore why some problems are harder to solve than others, and see how to reason with
                                    mathematical certainty
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>: Find the limits of what problems can be solved by computers. Proving which problems are
                                    impossible to solve with computers. Exploring P ≟ NP.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.Peter Linz, "An Introduction to Formal Language and Automata", Narosa Publishing
                    house.<br />
                    2.M.Sipser; Introduction to the Theory of Computation; Singapore: Brooks/Cole, Thomson
                    Learning.<br />
                    3. John.C.martin, "Introduction to the Languages and the Theory of Computation", Tata McGrawHill
                    <br />
                    4.K.Krithivasan and R.Rama; Introduction to Formal Languages, Automata Theory and
                    Computation; Pearson Education.<br />
                    5.J.E.Hopcroft, R.Motwani and J.D.Ullman , "Introduction to Automata Theory
                    Languages and computation", Pearson Education Asia.<br /> <br />
                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT305'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT305 &nbsp; Data Communication</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT 1 - Data Communicatuon Network</b>:Data communication concept, Basic concept of network, Types of networks (LAN, MAN and
                    WAN), Different network topologies like star, ring, hybrid, tree. Network models (OSI and
                    TCP/IP).
                    <br />
                    <b>UNIT 2 - Digital Transmission Techniques</b>: Digital-to digital conversions: NRZ, RZ, Biphase, Manchester coding, AMI. Analog-to-digital
                    conversions: Nyquist sampling theorem, quantization, Pulse code modulation, Delta modulation.
                    <br />
                    <b>UNIT 3 - Analog Transmission Techniques</b>:Digital-to-analog conversion: ASK, FSK, PSK, QAM. Signal constellation. Analog-to-analog
                    conversion: amplitude modulation, frequency modulation, phase modulation. <br />
                    <b>UNIT 4 - Bandwidth Utilisation Techniques</b>: Frequency Division Multiplexing, Time Division Multiplexing, Wavelength division
                    Multiplexing, Spread Spectrum. <br />
                    <b>UNIT 5 - Error Detection And Correction</b>: Errors in data communication: Types of errors, error detection and correction techniques, simple parity check, computation of CRC, Checksum, Hamming code. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>

                                <td>Understand the basics of data and signal</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Study OSI and TCP/IP reference models and compare the two.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Discuss the different types of network topologies and types of networks based on size with
                                    suitable applications.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Explore the existing types of transmission media and compare them with the state of the
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Study various techniques of analog and digital conversions.</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td> Understand various techniques used in the physical layer and data link layer.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1.William Stallings: Data & Computer Communications, PHI.  <br />
                    2.Andrew Tanenbaum, “Computer Networks” PHI.
                    <br />
                    3.Sklar, “Digital Communications fundamentals & Applications”.<br />
                    4.Keizer, “ Local Area Networks” McGraw Hill.
                    <br /> <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />


            {/* Rohit Prajpat Sections */}

            <section id='MAT301'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">MAT301 &nbsp; Introduction to Probability and Statistics</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br />
                <p>
                    <b>Unit-I Random variables:</b>
                    Discrete and Continuous Random variables, Distribution functions, Expectation and Variance of
                    Probability distribution, and Moment Generating function, Moments and properties. Discrete
                    distributions: Binomial, Poisson and Geometric distributions and their applications.<br />
                    Continuous distribution: Uniform, Exponential and Normal distributions, Normal approximation
                    to Binomial distribution and their applications.

                    <br />

                    <b>Unit II: Two-Dimensional Random Variables</b>: Bivariate Random Variables, Joint Distribution Functions (Discrete and Continuous), Marginal
                    and Conditional Distributions, Covariance and Correlation Coefficient, Transformation of random
                    variables. Regression Analysis, Linear and Non linear Regression, Multiple regression, Curve
                    fitting by method of least squares, fitting of straight lines, polynomials, exponential curves. <br />
                    <b>Unit III: Sampling Theory</b>Population and Sample, Statistical inference, Sampling with and without replacement, Random
                    samples, Population parameters, Sample statics, Sampling distributions, Sample mean, Sampling
                    distribution of means, Sample variances, Sampling distribution of variances, Case where
                    population variances is unknown, Unbiased estimates and efficient estimates, point estimate and
                    Interval Estimates, Confidence Interval estimates of population parameters.
                    <br />



                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Implement various divide and conquer based algorithms.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Understand concepts behind different distributions and their applications</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Understand the concept of joint probability distribution, Correlation Coefficient,
                                    Transformation of random variables,Regression Analysis
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Compute point estimation of parameters, explain sampling distributions, and understand
                                    the central limit theorem.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td> Construct confidence intervals on parameters for a single sample. </td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Introductory STATISTICS, Neil A. Weiss, 9th Edition. Pearson, 2012.<br />

                    2. Probability and Statistics for Engineers, Johnson, Miller and Freund, Pearson Education,8th Edition, 2015.
                    <br />
                    3. Fundamentals of Statistics, S. C. Gupta, 7th Edition, Himalaya Publishing House 2018. <br />
                    4. S. Ross: A First Course in Probability, 6th Ed., Pearson Education India, 2002.<br />
                    5. Fundamentals of Mathematical Statistics, S.C. Gupta, V.K Kapoor, Sultan Chand, <br />
                    6. Introduction to Mathematical Statistics, Robert V.Hogg, Joseph W.McKean and Allen T.
                    Craig, Second Edition, LPE Pearson Prentice hall, 2007. <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section >

            <br />

            <section id='ITL306'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL306 &nbsp; Design & Analysis of Algorithms Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br />
                <p>
                    <b>1</b>: Divide and conquer algorithms.
                    <br />
                    <b>2</b>:Greedy algorithms for minimum cost spanning tree, Knapsack problem, single source
                    shortest paths.
                    <br />
                    <b>3</b>:Dynamic Programming with applications.
                    <br />
                    <b>4</b>:Graph searching and traversal algorithms. <br />
                    <b>5</b>: Backtracking algorithms: 8-queen problem and Knapsack problem <br />
                    <b>6</b>: Branch and bound algorithm with applications. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Implement various divide and conquer based algorithms</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Implement various divide and conquer based algorithms.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Implement dynamic programming..</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Implement various graph searching and traversal algorithms
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td> Implement branch and bound algorithm for various problems.</td>
                            </tr>

                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL307'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL307 &nbsp; Microprocessor Labs</span></p>
                <p><span className="credits">1 credits (0-0-2)</span></p>
                <br />
                <p>
                    <b>1</b>: To develop a program to add two double byte numbers.
                    <br />
                    <b>2</b>:Greedy algorithms for minimum cost spanning tree, Knapsack problem, single source
                    shortest paths.
                    <br />
                    <b>3</b>:Greedy algorithms for minimum cost spanning tree, Knapsack problem, single source
                    shortest paths.
                    <br />
                    <b>4</b>To develop subroutine which will multiply two positive floating points numbers? <br />
                    <b>5</b>: To write program to evaluate P* Q*+R* & S are 8 bit binary numbers<br />
                    <b>6</b>: To write a program to divide a 4 byte number by another 4 byte number <br />

                    <b>7</b>:To write a program to divide an 8 bit number by another 8 bit number upto a
                    fractional quotient of 16 bit.<br />
                    <b>8</b>: Write a program for adding first N natural numbers and store the results in memory
                    location X.<br />
                    <b>9</b>:Write a program which decrements a hex number stored in register C. The
                    Program should half when the program register reads zero<br />
                    <b>10</b>:Write a program to introduce a time delay of 100 ms using this program as
                    subroutine display numbers from 01H to OAH with the above calculated time delay
                    between every two numbers<br />
                    <b>11</b> :N hex numbers are stored at consecutive memory locations starting from X. Find the
                    largest n:umber and store it at location Y.<br />

                    <b>12</b> :Interface a display circuit with the microprocessor either directly with the bus or
                    by using I/O ports. Write a programme by which the data stored in a RAM table is
                    displayed.<br />
                    <b>13</b>: To design and interface a circuit to read data from an A/D converter, using the 8255
                    A in the memory mapped I/O.<br />
                    <b>14</b>: To design and interface a circuit to convert digital data into analog signal using the
                    8255 A in the memory mapped I/O.<br /><b>15</b> :To interface a keyboard with the microprocessor using 8279 chip and transfer the output
                    to the printer.<br />
                    <b>16</b> :To design a circuit to interface a memory chip with microprocessor with given
                    memory map.<br />



                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To become familiar with the architecture and Instruction set of Intel 8085 microprocessors</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>  To provide practical hands on experience with Assembly Language Programming.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Develop ALP for 8 and 16 bit Arithmetic operations using 8086 microprocessor.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>  To familiarize the students with interfacing of various peripheral devices with 8085
                                    microprocessor
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td> Analyze the data transfer information through serial &amp; parallel ports.</td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td> To improve programming logic and concepts of 8085 microprocessor by developing
                                    programs for various applications.</td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITT350'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT350 &nbsp; Computer Networks</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION:</b>History and development of computer networks, networks topologies. Layering and protocols <br />
                    <b>UNIT II - PHYSICAL LAYER:</b>Different types of transmission media, errors in transmission: attenuation, noise. Encoding (NRZ,
                    NRZI, Manchester, AMI, etc.).
                    <br />
                    <b>UNIT III - DATA LINK LAYER AND SWITCHING:</b>MAC Layer: Aloha, CSMA, CSMA/CD, CSMA/CA protocols. Data Link Layer: Error detection
                    (Parity, CRC), Framing, Sliding Window, Stop and Wait protocols, HDLC. Switching Theory:
                    Circuit Switching, Message switching, Packet switching.

                    <br />
                    <b>UNIT IV - NETWORK LAYER:</b>Network layer: Internet Protocol, IPv6, ARP, DHCP, ICMP, Routing algorithms: Distance vector,Link state, Metrics, Inter-domain routing. Dijkstra, Bellman-Ford Algorithms. Subnetting,
                    Classless addressing, Network Address Translation.

                    <br />
                    <b>UNIT V - TRANSPORT AND APPLICATION LAYER:</b>Transport layer: UDP, TCP. Connection establishment and termination, sliding window revisited,
                    flow and congestion control, timers, retransmission, TCP extensions.
                    Application layer: DNS, SMTP, IMAP, HTTP, etc. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand the need for networking in general and computer networks in particular.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Study the prevalent TCP/IP reference model and understand various error, flow and access
                                    control strategies.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Study the IPV4 addressing and the strategies to delay the transition to IPV6 using techniques
                                    like subnetting, VLSM, NAT.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Understand routing in networks and study various routing algorithms.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Study the mechanism for connection establishment, termination between the nodes and the
                                    ways of reducing network congestion</td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Understand various application layer services</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. JF Kurose, KW Ross, Computer Networking: A Top-Down Approach.<br />
                    2. Behrouz A. Forouzan, Data communications and Networking.<br />
                    3. Andrew S. Tanenbaum, Computer Networks.<br />
                    4. William Stallings, Data and Computer Communications<br /> <br />


                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT351'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT351 &nbsp; Artificial Intelligence</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION:</b>Introduction to AI and intelligent agents.Problem Solving : Solving Problems by Searching,
                    heuristic search techniques, constraint satisfaction problems, stochastic search methods,
                    adversarial search,Game playing : minimax, alpha-beta pruning.

                    <br />
                    <b>UNIT II - KNOWLEDGE REPRESENTATION AND REASONING::</b>Building a Knowledge Base : Propositional logic, first order logic, Theorem Proving in First Order
                    Logic. Production Systems, Semantic Nets, Frames and Scripts Formalisms. Resolution in
                    Predicate Logic, Unification, Strategies for Resolution by Refutation. Knowledge Acquisition and
                    learning: Learning from examples and analogy, Rote learning, Neural Learning, Integrated
                    Approach. Planning, partial order planning. Uncertain Knowledge and Reasoning, Probabilities,
                    Bayesian Networks.
                    <br />
                    <b>UNIT III - INTRODUCTION TO MACHINE LEARNING:</b>Network layer: Machine Learning, Supervised Learning, Unsupervised Learning, Reinforcement Learning.
                    Introduction to Probability, Basics Linear Algebra, Statistical Decision Theory – Regression &
                    Classification, Bias – Variance, Overfitting and complexity; training, validation, test data.

                    <br />
                    <b>UNIT IV - EXPERT SYSTEM::</b>Existing Systems (DENDRAL, MYCIN), domain exploration, Meta Knowledge, Expertise
                    Transfer, Self Explaining System.Fuzzy logic: Fuzzy Logic Propositional logic, Membership
                    functions, Fuzzy logic, Fuzzy rule generation, De-fuzzification, Time dependent fuzzy logic,
                    Temporal fuzzy logics, Case study-to use fuzzy logic for processes control problem
                    Programming Language: Introduction to programming Language- LISP, PROLOG <br />
                    <b>UNIT V - NEURAL NETWORKS:</b>Overview of different forms of learning, Learning Decision Trees, Neural Networks- Basics of
                    Neural Networks: Perceptrons, Feedforward nets Backpropagation algorithm, preliminary
                    understanding of unsupervised learning.
                    Pattern Recognition: Introduction to Pattern Recognition, Structured Description, Symbolic
                    Description, Machine perception, Line Finding, Interception, Semantic & Model, Object
                    Identification, Speech Recognition<br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Gain historical perspective of AI and its formation</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>  Introduce the basic principles of AI problem solving</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Apply basic principles in problem solving, inference, perception, knowledge representation
                                    and learning.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Investigate applications of AI techniques in intelligent agents, expert systems, machine
                                    learning models.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>AI development tools and techniques.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Rich & Knight, “Artificial Intelligence”.<br />
                    2. Elamie, “artificial Intelligence”, Academic Press..<br /> <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT352'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT352 &nbsp; Computer Graphics</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION:</b>computer graphics, Co-ordinate representation, Pixel, Raster Scan & Random Scan methods,
                    color, CRT Raster, scan basics, video basics, interactive devices, graphics input and output
                    devices, mouse, track ball, light pen, digitizer, thumb wheel, raster scan graphics, applications. <br />
                    <b>UNIT II - Line GENERATION:</b>Points and lines generation algorithm, DDAlines drawing algorithm, Bresenham’s lines drawing
                    algorithm, circle generating algorithm, midpoint circle algorithm,midpoint ellipse generating
                    algorithm, other curves, conic sections, polynomial and spline curves, Pixels addressing, filledarea primitives, scan-line polygon filled algorithms, inside-outside tests, scan-line fill of curved
                    boundary algorithms,boundary fill algorithms,flood-fill algorithms, fill-area functions, character
                    generation. <br />
                    <b>UNIT III - SEGMENTS:</b>Segments table, Creating, Deleting and renaming a segment Visibility, Image transformation <br />
                    <b>UNIT IV - TRANSFORMATION:</b>2D Transformation, An introduction to 3D transformation, Projections, Light, color and shading. <br />
                    <b>UNIT V - WINDOWING AND CLIPPING: </b>Viewing transformation, Clipping. Generalized clipping IN 2D.
                    Hidden line and surfaces: Back-face Removal Algorithms, Hidden line methods
                    Rendering and Illumination: Introduction to curve generation, Bezier, Hermite and B-spline
                    algorithms and their Comparisons. <br />
                    <br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand the basics of computer graphics, different graphics systems and applications of
                                    computer graphics.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td> Provide an understanding of how to scan convert the basic geometrical primitives, how to
                                    transform the shapes to fit them as per the picture definition.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Use of geometric transformations on graphics objects and their application in composite
                                    form.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Extract scene with different clipping methods and its transformation to graphics display
                                    device.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Explore projections and visible surface detection techniques for display of 3D scene on
                                    2D screen.
                                </td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td> Render projected objects to naturalize the scene in 2D view and use of illumination
                                    models for this.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Computer Graphics (Principles and Practice) by Foley, van Dam, Feinerand Hughes, Addisen
                    Wesley.<br />
                    2. Computer Graphics by D Hearn and P M Baker, Printice Hall of India.<br />
                    3. Mathematical Elements for Computer Graphics by D F Rogers, McGraw Hill.<br />
                    4. Procedural Elements for Computer Graphics by D F Rogers, McGraw Hill. <br />
                    <br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />



            {/* Ashish Tiwari Sections */}

            <section id='ITT353'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT353 &nbsp; Big Data</span></p>
                <p><span className="credits">4 credits (3-0-1)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION:</b> <br />
                    Big Data Overview, Introduction to the Big Data problem. Current challenges, trends, and
                    applications, Algorithms for Big Data analysis. Data sets, Mining and learning algorithms that deal with large datasets Technologies for Big Data management. Big Data technology and tools, special consideration made to the Map-Reduce paradigm and the Hadoop ecosystem.<br />

                    <b>Unit II - DATA SCIENCE:</b> <br />
                    What is data sciences, The rising and importance of data sciences, Big data analytics in industry verticals, Data Analytics Lifecycle and methodology, Data Understanding, Data Preparation.<br />

                    <b>Unit III - MODELING:</b><br />
                    Evaluation, Communicating results, Deployment, Data exploration & preprocessing. <br />

                    <b>Unit IV - MEASURES AND EVALUATION:</b><br />
                    Data Analytics: Theory & Methods, Supervised learning, Linear/Logistic regression, Decision trees, Naïve Bayes, Unsupervised learning, K-means clustering, Association rules <br />

                    <b>Unit V - UNSTRUCTURED DATA ANALYTICS:</b><br />
                    Viewing transformation, Clipping. Generalized clipping IN 2D.
                    Hidden line and surfaces: Back-face Removal Algorithms, Hidden line methods
                    Rendering and Illumination: Introduction to curve generation, Bezier, Hermite and B-spline
                    algorithms and their Comparisons. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand Big Data, its platform and its use cases.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Provide an overview of Apache Hadoop ,HDFS Concepts and Interfacing with HDFS.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Understanding Data Sciences and Data life cycle.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Understanding and Using Supervised and Unsupervised Learning Algorithms.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Tools and Technologies for Unstructured Data Analytics.
                                </td>
                            </tr>
                            <tr>
                                <td>CO6</td>
                                <td>Implementing Machine Learning algorithms using Python.</td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Big Data: A Revolution That Will Transform How We Live, Work, and Think by Viktor
                    Mayer-Schönberger, Kenneth Cukier. <br />
                    2. Hadoop: The Definitive Guide by Tom White (Goodreads Author), Doug Cutting , oreily
                    Publiactions. <br />
                    3. Real-Time Big Data Analytics: Emerging Architecture [Kindle Edition], Mike Barlow. <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT354'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITT354 &nbsp; Object-Oriented Programming II with Java</span></p>
                <p><span className="credits">3 credits (3-0-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION:</b> <br />
                    What is Java? Background/History of Java, Java Virtual Machine, JVM Architecture, Byte code, HotSpot JVM and JIT Compilation, Basics of OOP. Introduction to Classes and Objects. Data types. Garbage collection: Eden space, Survivor Space, Tenured generation, Permanent generation, Code cache, loops and flow control.<br />

                    <b>UNIT II - OBJECT ORIENTED PROGRAMMING CONCEPTS:</b> <br />
                    Abstraction, Encapsulation, Polymorphism and Overloading, Constructors and destructors scope of declarations, Access Control, Nested and Inner classes. Array handling. Using extends keyword, subclass, super-class, over- riding methods, dynamic method dispatch, The Object class, Abstract and final classes. Packages: defining, importing, Access Control. Interface: Defining, Implementing and applying interface. Wrapper classes.<br />

                    <b>UNIT III - EXCEPTION AND STRING HANDLING:</b><br />
                    Basic exceptions, user defined exceptions, catching exceptions – try, catch and multi try catch, throwing and re-throwing, finally clause. String Handling: Creation, concatenation and conversion of a string, searching and modification, string comparison. StringBuffer and StringBuilder classes and Date class.
                    <br />

                    <b>UNIT IV - CONCURRENT PROGRAMMING AND FILE HANDLING:</b><br />
                    Generics & Collections: List interface, ArrayList, LinkedList, Queue, Stack,
                    Threads: Create new threads – extending java.lang.Thread, implementing java.lang.Runnable
                    Interface, Understanding thread execution, multithreading, thread priorities and scheduling, synchronization Introduction to java.util.concurrent classes and interface and using java.util.concurrent.Callable interface. Introduction to Fork-Join Framework.
                    File handling, Creating, writing, reading, updating, touching and deleting files, Byte Streams and Character Streams, InputStream & OutputStream classes and their subclasses, Reader and Writer classes and their subclasses. <br />

                    <b>UNIT V - GUI COMPONENTS:</b><br />
                    Introduction to AWT and Swing, frames, panels, buttons and events, layout managers, text fields, labels. Working with controls and layout managers, event handling and data validation, Applets. Introduction to JavaFx.<br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand various basics related to java programming, object-oriented programming and other concepts like JVM, JVM architecture, JIT compilation.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Understand the underlying principles of object-oriented programming like abstraction, polymorphism etc and getting familiar with various java classes. Learn to define and import packages, implement interfaces.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Getting familiar with exception and string handling in java. Study creation, concatenation and conversion of a string, searching and modification, string comparison. String Buffer and StringBuilder classes and Date class.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td> Have detailed knowledge on concurrent programming and file handling. Study various data collectors available in java like ArrayList, LinkedList, Queue etc. Understanding thread execution, multithreading, thread priorities and scheduling, synchronization. Understanding file handling, creating writing, reading, updating, touching and deleting files, Byte Streams and Character Streams, InputStream &amp; OutputStream classes and their subclasses, Reader and Writer classes and their subclasses.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>
                                    Be familiar with graphical components like buttons, labels, events, windows etc through which user can interact with the applications. Working with controls and layout managers, event handling and data validation.
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Java for Programmers, P.J. Dietel, H. M. Dietel, Pearson Education. <br />
                    2. Java SE 6, Joel Murach, A. Steelman, SPD Pvt. Ltd. <br />
                    3. Head first java, Kathy Sierra, Bert Bates, Oreilly. <br />
                    4. Core Java, Cay Horstman and Gary Cornell, Prentice Hall. <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITL355'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL355 &nbsp; Computer Networks Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br />
                <p>
                    1. Study and implementation of colour coding standards of guided media (UTP). <br />
                    2. Implementation and understanding of basic network utilities: ping, ipconfig/ifconfig,
                    mstsc, nslookup, tracert. <br />
                    3. Network traffic capture and analysis using Wireshark. <br />
                    4. Introduction to Cisco Packet Tracer: Building a LAN with HUBs and Switches, understand
                    and implement address learning in switches. <br />
                    5. Router Configuration Using Packet Tracer, IP addressing (static and dynamic), subnetting. <br />
                    6. Static/Dynamic Route Configuration. <br />
                    7. Implementation of routing protocols (RIP, OSPF, BGP). <br />
                    8. Standard access control list (ACL) configuration, Extended access control list (ACL)
                    configuration. <br />
                    9. Implementation of flow control protocols. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand colour coding of guided media and create crossover and straight through cable.
                                </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Implement basic network utilities and analyse network traffic using Wireshark tool.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td> Hands-on Cisco Packet Tracer by building basic networks and configuring internetworking devices like router, switch.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Implement static and dynamic routing in Packet Tracer and configure access control lists.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>
                                    Simulate wireless networks using NS3.
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL356'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL356 &nbsp; Artificial Intelligence Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br />
                <p>
                    <h4>AI PYTHON LAB CONTENTS</h4>
                    1. Input & Output <br />
                    2. Operators and Arithmetic <br />
                    3. Facts & Variables <br />
                    4. Simple facts and facts with arguments <br />
                    5. Rules & Predicates <br />
                    6. Simple Predicates, Predicate Inference, Goal queries <br />
                    7. Recursion <br />
                    8. Graph Traversal <br />
                    9. Depth First Search, Breadth First Search <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>
                                    Understand simple facts and variables
                                </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>
                                    Implement and apply simple predicates, predicate inference and goal queries.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>
                                    Demonstrate the proficiency in applying scientific methods to models of machine learning.
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL357'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL357 &nbsp; Computer Graphics Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br />
                <p>
                    1. Point drawing to understand co-ordinate system of display device. <br />
                    2. To implement Bresenham’s algorithms for line generation. <br />
                    3. To implement DDA algorithm for line generation. <br />
                    4. To implement midpoint circle generation algorithm. <br />
                    5. To implement midpoint ellipse generation algorithm. <br />
                    6. To implement flood-fill and boundary fill algorithm. <br />
                    7. To perform 2D Transformations such as translation. <br />
                    8. To perform 2D Transformations such as rotation. <br />
                    9. To perform 2D Transformations such as scaling. <br />
                    10. To perform 2D Transformations such as reflection. <br />
                    11. To perform 2D Transformations such as shearing. <br />
                    12. To implement Cohen-Sutherland 2D clipping and window-viewport mapping. <br />
                    13. To perform 3D Transformations such as translation, rotation and scaling. <br />
                    14. To visualize projections of 3D images. <br />
                    15. To convert between color models. <br />
                    16. To implement text compression algorithm using librarires. <br />
                    17. To implement image compression algorithm using librarires. <br />
                    18. To perform animation using any Animation software. <br />
                    19. To perform basic operations on image using any image editing software. <br />
                    20. Implementation of viewing/rendering pipeline. <br /> <br />


                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>
                                    Understand the basic concepts of computer graphics.
                                </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>
                                    Design scan conversion problems using C programming.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>
                                    Apply clipping and filling techniques for modifying an object.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>
                                    Understand the concepts of different type of geometric transformation of objects in 2D and 3D.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>
                                    Understand the practical implementation of modeling, rendering, viewing of objects in 2D.
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL358'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading">ITL358 &nbsp; Object-Oriented Programming II with Java Lab</span></p>
                <p><span className="credits">1 credits (0-0-1)</span></p>
                <br />
                <p>
                    1. Java package with simple stack and queue class. <br />
                    2. Complex number manipulation. <br />
                    3. Date class similar to java.util package. <br />
                    4. Implementing dynamic polymorphism in java. <br />
                    5. Java interface for ADT stack. <br />
                    6. Developing a simple paint like program using applet. <br />
                    7. Developing a scientific calculator. <br />
                    8. Developing a template for linked list. <br />
                    9. Develop a multi threaded producer consumer Application. <br />
                    10. Generating prime numbers and Fibonacci series. <br />
                    11. Multithreaded GUI application. <br /><br />


                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>
                                    Implementing the underlying principles of object-oriented programming like abstraction, polymorphism etc and various java classes.
                                </td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>
                                    Learn to define and import packages, implement interfaces.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>
                                    Implementing exception handling, creating user defined exceptions, catching exceptions. Creation, concatenation and conversion of a string, searching and modification, string comparison. Implementing String Buffer and StringBuilder classes and Date class.
                                </td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>
                                    Using various data collectors available in java like ArrayList, LinkedList, Queue etc. Implementing multithreading, thread priorities and scheduling, synchronization. Implementing various file handling, creating, writing, reading, updating, touching and deleting files, Byte
                                    Streams and Character Streams, InputStream &amp; OutputStream classes and their subclasses, Reader and Writer classes and their subclasses.

                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>
                                    Executing graphical components like buttons, labels, events, windows etc through which user can interact with the applications.
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </p>
            </section>

            <br />


            {/* Deepak Kachhot Sections */}

            {/* Tour And Training Not Found */}

            <section id='ITT401'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITT401 &nbsp; Wireless & Mobile Communication</span>
                </p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION TO WIRELESS NETWORKS</b>:<br />Introduction-Evolution of mobile radio
                    communications-Differences Between Wireless And Fixed Telephone Networks-Development Of Wireless
                    Networks- Traffic Routing In Wireless Networks- Integrated Services Digital Network (ISDN)- Protocols
                    For Network Access. <br /><br />
                    <b>UNIT II - PRINCIPLES OF CELLULAR WIRELESS NETWORKS</b>:<br /> Introduction- Frequency Reuse- Channel
                    Assignment Strategies-Handoff Strategies- Interference And System Capacity- Trunking And Grade Of
                    Service-Improving Capacity In Cellular Systems. <br /><br />
                    <b>UNIT III - MULTIPLE ACCESS TECHNIQUES</b>: <br />Introduction-Multiple Access Techniques: FDMA,TDMA,
                    CDMA- Space Division Multiple Access- Spread Spectrum - Packet Radio. <br /><br />
                    <b>UNIT IV - WIRELESS SYSTEMS AND STANDARDS</b>:<br /> Global System for Mobile communication - CDMA
                    Digital Cellular Standard (IS-95) - CT2 Standard for Cordless Telephones- Digital European Cordless
                    Telephones (DECT). Mobile communication: Mobile data management in 1G,2G,3G, Frequency reuse, sectoring,
                    GSM and CDMA architecture, EDGE technology, Mobile IP, Mobile Agents. <br /><br />
                    <b>UNIT V - MOBILE AND WIRELESS SECURITY</b>:<br /> Creating Secure Environment- Security Threats-WAP
                    Security: TLS-WTLS-IPSec- Application Level Security- Smart Client: Architecture, Security-Firewalls-
                    VPNs-Two factor Authentication. Mobile Communication & application development. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand the need for wireless communication.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Study cellular concepts design capacity and different methods to eliminate interference.
                                </td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Study various access techniques like FDMA, TDMA, etc and wireless networks and
                                    wireless protocols like WAP.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Understanding wireless standards like GSM, CDMA etc.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Understanding various security issues and methods to increase security in wireless systems.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Theodore.S.Rappaport, Wireless Communications-Principles and practice, Prentice Hall Communications
                    Engineering and Emerging Technologies Series, Upper Saddle River, New Jersey. <br />
                    2. Martyn Mallick, Mobile and Wireless Design Essentials, Wiley Dreamtech India pvt ltd. <br />
                    3. Geoff Varall, Roger Belcher,3G Handset & Network Design, Wiley Dreamtech India pvt ltd. <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT402'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITT402 &nbsp; Information Security</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION TO INFORMATION SECURITY</b>:<br /> Introduction, the History of Information
                    Security, What Is Security, CNSS Security Model, Components of an Information System, Balancing
                    Information Security and Access, Approaches to Information Security, the Systems Development Life the
                    Security Systems, Development Life Cycle, Security Professionals and the Organization. <br /><br />
                    <b>UNIT II - THE NEED FOR SECURITY</b>:<br /> Introduction, Business Needs First, Threats, Attacks, And
                    Secure Software Development. Planning for Security: Introduction, Information Security Planning and
                    Governance, Information Security Governance, Information Security Policy, Standards, and Practices, The
                    Information Security Blueprint ,Security Education, Training, and Awareness Program, Continuity
                    Strategies, Model for a Consolidated Contingency Plan, Law Enforcement Involvement.<br /><br />
                    <b>UNIT III - IMPLEMENTING AND MAINTENANCE</b>:<br /> Introduction, Information Security Project
                    Management, Developing the Project Plan, Project Planning Considerations, Scope Considerations, the Need
                    for Project Management, Technical Aspects of Implementation, Conversion Strategies,the Bull’s-Eye Model,
                    Considerations for Organizational Change, Information Systems Security Certification and Accreditation.
                    <br /><br />
                    <b>UNIT IV - CRYPTOGRAPHY</b>:<br /> Introduction, Foundations of Cryptology, Cipher Methods,
                    Substitution Cipher, Transposition Cipher, Exclusive OR, Vernam Cipher, Book or Running Key Cipher, Hash
                    Functions, Cryptographic Algorithms, Symmetric Encryption, Asymmetric Encryption, Examples, Encryption
                    Key Size, Cryptographic Tools, Public-Key Infrastructure (PKI), Digital signature ,Digital Certificates,
                    Hybrid Cryptography Systems, Steganography, Attacks on Cryptosystems, Man-in-the-Middle Attack,
                    Correlation Attacks, Dictionary Attacks, Timing Attacks, Defending Against Attacks, Protocols for Secure
                    Communications, S-HTTP and SSL, S/MIME, PEM, and PGP, SET, WEP and WPA,IEEE 802.1x based authentication,
                    IPSec and PGP. <br /><br />

                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To study the history, need, and various approaches to Information security.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>To understand the use of encryption and decryption.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To study the various technical aspects and strategies of implementation of Symmetric
                                    Encryption.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To study the various technical aspects and strategies of implementation of Asymmetric
                                    Encryption.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Achieving Authentication using keys.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Michael E. Whitman, Herbert J. Mattord, “Principles of information security”,Course Technology, Cengage
                    Learning. <br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT403'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITT403 &nbsp; Image Processing</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION</b>:<br /> What is digital image processing? The origins of digital image
                    processing, Fundamental steps in digital image processing, components of an image processing system.
                    <br /><br />
                    <b>UNIT II - DIGITAL IMAGE FUNDAMENTALS</b>:<br /> Image sensing and acquisition, Image sampling and
                    quantisation, basic relationships between pixels, linear and non-linear operations.<br /><br />
                    <b>UNIT III - IMAGE ENHANCEMENT IN THE SPATIAL DOMAIN</b>:<br /> Gray level transformations, histogram
                    processing, enhancement using arithmetic/logic operations, spatial filtering, smoothing and sharpening.
                    Image enhancement in Frequency Domain: Fourier transform and frequency domain, smoothing and sharpening
                    frequency domain filters
                    Image Restoration: A Model of the Image Degradation/Restoration Process. Inverse Filtering, Minimum Mean
                    Square Error (Wiener) Filtering. Constrained Least Squares Filtering, Geometric Mean Filter, Geometric
                    Transformations. <br /><br />
                    <b>UNIT IV - COLOUR IMAGE PROCESSING</b>:<br /> Fundamentals, models, colour transformations, smoothing
                    and sharpening, colour segmentation and noise.
                    Image Segmentation: Detection of discontinuities, edge linking and boundary detection, thresholding,
                    region based segmentation, morphological watersheds.
                    Representation and description: Representation, boundary descriptors, regional descriptors, relational
                    descriptors. <br /><br />
                    <b>UNIT V - IMAGE COMPRESSION</b>:<br />Morphological Image Processing, Representation and
                    Description.<br /><br />
                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To understand what a digital image is and the steps involved in image processing.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>To understand image acquisition process and develop any image processing application.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To learn different techniques employed for the enhancement of image.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To understand different color image models and learn different causes of image degradation
                                    and overview of image restoration.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>To understand the need for image compression and to learn spatial and frequency domain
                                    techniques for image compression, segmentation of image and understand morphological
                                    image processing.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Rafael C Gonzalez, Richard E Woods, Digital Image Processing - Pearson Education <br />
                    2. Rafael C Gonzalez, Richard E Woods, Digital Image Processing with MATLAB- Pearson Education.<br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITT404'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITT404 &nbsp; Cloud Computing</span></p>
                <p><span className="credits">4 credits (3-1-0)</span></p>
                <br />
                <p>
                    <b>UNIT I - INTRODUCTION TO CLOUD COMPUTING</b>:<br /> Definition, Characteristics, Components, Cloud
                    provider, SAAS, PAAS, IAAS and Others, Virtualization concepts; Types of Virtualization & its benefits,
                    Introduction to Various Virtualization OS(Vmware , KVM etc), HA/DR using Virtualization, Moving VMs ,SAN
                    backend concepts,Cloud Fundamentals; Cloud Building Blocks, Understanding Public & Private cloud
                    environments.<br />
                    Cloud Technologies, Study of Hypervisors. <br /><br />
                    <b>UNIT II - WEB SERVICES, AJAX AND MASHUPS</b>:<br /> Web services: SOAP and REST, SOAP versus REST,
                    AJAX: asynchronous 'rich' interfaces, Mashups: user interface services.<br />
                    Virtualization Technology: Virtual machine technology, virtualization applications in enterprises,
                    Pitfalls of virtualization.<br /><br />
                    <b>UNIT III - MULTI TENANT SOFTWARE</b>:<br /> Multi-entity support, Multi-schema approach,
                    Multi-tenance using cloud data stores, Data access control for enterprise applications.Data in the cloud
                    Relational databases,<br />
                    Cloud file systems: GFS and HDFS, BigTable, HBase and Dynamo. Map-Reduce and extensions: Parallel
                    computing, The map-Reduce model, Parallel efficiency of Map-Reduce, Relational operations using
                    Map-Reduce, Enterprise batch processing using Map-Reduce. <br /><br />
                    <b>UNIT IV - CLOUD COMPUTING SECURITY CHALLENGES</b>:<br /> Issues in cloud computing, Implementing real
                    time application over cloud platform Issues in Intercloud environments, QOS Issues in Cloud,
                    Dependability, data migration, streaming in Cloud. Quality of Service (QoS) monitoring in a Cloud
                    computing environment .Vulnerability assessment tool for cloud, Privacy and Security in cloud
                    Virtualization security management- virtual threats, VM Security Recommendations, VM-Specific Security
                    techniques, Secure Execution Environments and Communications in cloud. <br /><br />
                    <b>UNIT V - SETTING UP CLOUD</b>:<br />How to build private cloud using open source tools, Understanding
                    various cloud plugins, Setting up your own cloud environment; Auto provisioning, Custom images,
                    Integrating tools like Nagios ,Integration of Public and Private cloud.<br /><br />
                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Understand various basic concepts related to cloud computing technologies.<br />Understand
                                    the architecture and concept of different cloud models: IaaS, PaaS, SaaS<br />Understand big
                                    data analysis tools and techniques.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Understand the underlying principle of web services, cloud virtualization, cloud storage,
                                    data management and data virtualization.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Understand different Multi-tenant software, Be familiar with cloud file systems.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Have detailed knowledge on cloud computing security challenges and other issues.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Be familiar with setting up cloud. Understanding integrating tools.</td>
                            </tr>
                        </tbody>
                    </table>

                    <b className="courseD-heading">Text Books:</b> <br />
                    1. Cloud Computing for Dummies by Judith Hurwitz, R.Bloor, M.Kanfman, F.Halper<br />
                    2. Enterprise Cloud Computing by Gautam Shroff,Cambridge<br />
                    3. Cloud Security by Ronald Krutz and Russell Dean Vines, Wiley-India<br /><br />

                    <a href="https://www.youtube.com/watch?v=LSIrG0QnEJ8&list=PLUbapHgKkROk71NY-Q3lYLHIyKCCg37oM"
                        target="_blank">Dr. Janibul Bashir C Programming Playlist</a>
                </p>
            </section>

            <br />

            <section id='ITL405'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITL405 &nbsp; Information Security Lab</span></p>
                <p><span className="credits">1 credits (0-0-2)</span></p>
                <br />
                <p>
                    01. &nbsp;&nbsp;Deploying virtual machines testbed over virtualization software such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;VMPlayer or VirtualBox.<br />
                    02.&nbsp;&nbsp; Creating test machines
                    including Kali/Backtrack and vulnerable machine.<br />
                    03.&nbsp;&nbsp; Configure and demonstrate use of Traffic monitoringtool such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Wireshark and tcpdump<br />
                    04.&nbsp;&nbsp; Configure and demonstrate use of basic Enumeration tools such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ping,traceroute, nslookup,dig, nmap<br />
                    05.&nbsp;&nbsp; Configure and demonstrate use of fingerprinting tools such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nmap(Zenmap) ,hping3,DMitry.<br />
                    06.&nbsp;&nbsp; Configure and demonstrate use of vulnerability assessment tool such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nessus, openVAS.<br />
                    07.&nbsp;&nbsp; Configure and demonstrate use exploit tool such as:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;metasploit framework.<br />
                    08.&nbsp;&nbsp; Demonstrate use of a password cracking tool using brute force attack, dictionary attack
                    rainbow
                    tables.<br />
                    09.&nbsp;&nbsp; Configure and demonstrate use of computer forensics tool.<br />
                    10.&nbsp;&nbsp; Configuring and deploying Firewall.<br />
                    11.&nbsp;&nbsp; Configure and demonstrate use of IDS tool such as snort.<br />
                    12.&nbsp;&nbsp; Configuring and deploying IDPS.<br /><br />
                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>To create and understand use of vulnerable machines.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>To use traffic analysis, enumeration and fingerprinting tools.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>To understand use of password cracking tools.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>To deploy tools to protect a system.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL406'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITL406 &nbsp; Image Processing Lab</span></p>
                <p><span className="credits">1 credits (0-0-2)</span></p>
                <br />
                <p>
                    01. &nbsp;&nbsp;Display an image and its histogram.<br />
                    02.&nbsp;&nbsp; Perform shrinking, zooming and cropping of an image.<br />
                    03.&nbsp;&nbsp; Perform the experiment for histogram equalization.<br />
                    04.&nbsp;&nbsp; Perform blurring and de-blurring on an image.<br />
                    05.&nbsp;&nbsp; Implement the spatial image enhancement functions on a bitmap image – Mirroring
                    (Inversion).<br />
                    06.&nbsp;&nbsp; Implement the spatial image enhancement functions on a bitmap image – Rotation
                    (Clockwise).<br />
                    07.&nbsp;&nbsp; Implement the spatial image enhancement functions on a bitmap image – Enlargement
                    (Double Size).<br />
                    08.&nbsp;&nbsp; Implement (a) Low Pass Filter (b) High Pass Filter.<br />
                    09.&nbsp;&nbsp; Implement (a) Arithmetic Mean Filter (b) Geometric Mean Filter.<br />
                    10.&nbsp;&nbsp; Removal of salt and pepper noise.<br />
                    11.&nbsp;&nbsp; Implement Smoothing and Sharpening of an eight bit color image.<br />
                    12.&nbsp;&nbsp; Implement (a) Boundary Extraction Algorithm (b) Graham's Scan Algorithm.<br />
                    13.&nbsp;&nbsp; Implement (a) Edge Detection (b) Line Detection.<br /><br />
                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Display image, its histogram, zoom and shrink image.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Perform enhancing operations on the image using spatial filters and frequency domain
                                    filters. Remove noise from image.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Use transforms and analyze the characteristics of the image.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Perform segmentation operations in the images.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </section>

            <br />

            <section id='ITL407'>
                <hr /> <br />
                <p><span className="title courseD-mainHeading" >ITL407 &nbsp; Cloud Computing Lab</span></p>
                <p><span className="credits">1 credits (0-0-2)</span></p>
                <br />
                <p>
                    01. &nbsp;&nbsp;Introduction to cloud computing.<br />
                    02.&nbsp;&nbsp; Implementation of SOAP Web services in C#/JAVA Applications.<br />
                    03.&nbsp;&nbsp; Implementation of para-virtualization using VM Ware’s Workstation/Oracle’s Virtual Box and Guest O.S.<br />
                    04.&nbsp;&nbsp; Implementation of IAAS, SAAS.<br />
                    05.&nbsp;&nbsp; Installation and Configuration of Hadoop.<br />
                    06.&nbsp;&nbsp; Create an application (Ex: Word Count) using Hadoop Map/Reduce.<br />
                    07.&nbsp;&nbsp; Case Study: PAAS (Facebook, Google App Engine)<br />
                    08.&nbsp;&nbsp; Case Study: Amazon Web Services.<br /><br />
                    <b className="courseD-heading">Course Outcomes:</b> <br />

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>CO1</td>
                                <td>Student should understand and appreciate cloud architecture.</td>
                            </tr>
                            <tr>
                                <td>CO2</td>
                                <td>Student can create and run virtual machines on open source OS.</td>
                            </tr>
                            <tr>
                                <td>CO3</td>
                                <td>Student can implement Infrastructure, storage as a Service.</td>
                            </tr>
                            <tr>
                                <td>CO4</td>
                                <td>Student can install and configure Hadoop and Map/Reduce.
                                </td>
                            </tr>
                            <tr>
                                <td>CO5</td>
                                <td>Students can install and appreciate security features and user management for cloud
                                    using web application.</td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </section>

            {/* Pre Project Not Found */}

            {/* Seminar Not Found */}

            {/* Machine Learning Not Found */}

            {/* Project Not Found */}

            {/* Economics & Buisness Management Not Found */}


        </div >
    )
}

export default CourseDes